import ThemeProvider from '@rezdy/components/ThemeWrapper';
import React, { Suspense } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalStyles from './components/GlobalStyles';
import LoadingDots from './components/LoadingDots';
import routes from './constants/routes';
import { pages } from './pages';
import gmt from './services/gmt';
import routing from './services/routing';

const renderPage = (Component: any) => (
    // Wrap component in suspense to handle i18n backend loads
    <Suspense fallback={<LoadingDots />}>
        <ErrorBoundary>
            <Component />
        </ErrorBoundary>
    </Suspense>
);

class App extends React.PureComponent {
    componentDidMount() {
        gmt.render();
    }

    render() {
        return (
            <ThemeProvider>
                <React.Fragment>
                    <GlobalStyles />
                    <Router history={routing.history}>
                        <Switch>
                            {/* Redirect deprecated paths to it's replacements */}
                            <Redirect
                                from={routes.SIGN_UP_WITH_EMAIL}
                                to={{
                                    pathname: routes.HUBSPOT_SIGN_UP,
                                    search: window.location.search,
                                }}
                            />
                            <Redirect
                                from={routes.SIGN_UP_SELECTION}
                                to={{
                                    pathname: routes.HUBSPOT_SIGN_UP,
                                    search: window.location.search,
                                }}
                            />
                            <Redirect
                                from={routes.SIGN_UP_WITH_EMAIL_V3}
                                to={{
                                    pathname: routes.HUBSPOT_SIGN_UP,
                                    search: window.location.search,
                                }}
                            />
                            {pages.map(page => (
                                <Route
                                    key={page.route}
                                    path={page.route}
                                    component={() => renderPage(page.component)}
                                />
                            ))}

                            <Redirect to={`${routing.link(routes.SIGN_IN)}`} />
                        </Switch>
                    </Router>
                </React.Fragment>
            </ThemeProvider>
        );
    }
}

export default App;
